 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		2: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		2: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"route-Game~route-HarvestBreadfruit~route-Index","1":"route-HarvestBreadfruit~route-Invite","4":"route-DownloadApp","5":"route-FreeCash","6":"route-Game","7":"route-GameSearch","8":"route-HarvestBreadfruit","9":"route-Index","10":"route-Invite","11":"route-InviteWheel","12":"route-LanguageChange","13":"route-Leader","14":"route-Leaderboard","15":"route-Login","16":"route-LuckyDraw","17":"route-MakeMoney","18":"route-PartnerGame","19":"route-PiggyBank","20":"route-Setting","21":"route-TaskCenter","22":"route-WheelTotal","23":"route-WreathOfThorns"}[chunkId]||chunkId) + ".chunk." + {"0":"889d1","1":"26ab2","4":"a7bde","5":"f3160","6":"1e5b7","7":"c6fcb","8":"08b6f","9":"932ec","10":"4e482","11":"55a06","12":"a27fc","13":"f1475","14":"1a05b","15":"35d0b","16":"ace6a","17":"5ac4c","18":"16328","19":"a3550","20":"1520c","21":"cde52","22":"2c6c2","23":"c7b49"}[chunkId] + ".esm.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"16":1,"17":1,"18":1,"19":1,"21":1,"22":1,"23":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"route-Game~route-HarvestBreadfruit~route-Index","1":"route-HarvestBreadfruit~route-Invite","4":"route-DownloadApp","5":"route-FreeCash","6":"route-Game","7":"route-GameSearch","8":"route-HarvestBreadfruit","9":"route-Index","10":"route-Invite","11":"route-InviteWheel","12":"route-LanguageChange","13":"route-Leader","14":"route-Leaderboard","15":"route-Login","16":"route-LuckyDraw","17":"route-MakeMoney","18":"route-PartnerGame","19":"route-PiggyBank","20":"route-Setting","21":"route-TaskCenter","22":"route-WheelTotal","23":"route-WreathOfThorns"}[chunkId]||chunkId) + ".chunk." + {"0":"a4b1c","1":"31d6c","4":"d6a46","5":"a2b02","6":"91f06","7":"1746d","8":"216f7","9":"42876","10":"892f9","11":"b9e83","12":"1b7c5","13":"1e0b1","14":"9267f","15":"31d6c","16":"2f995","17":"8fa0f","18":"9d3c2","19":"d27ae","20":"31d6c","21":"c7350","22":"62f1b","23":"69b8e"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = "Pq/i");
